<template>

  <div>

    <t-blackout @onOpen="onBlackoutImage(true)" @onClose="onBlackoutImage(false)" v-model="show"
                :busy="blackoutImageZoomBusy">

      <div class="d-flex align-content-center justify-content-center overflow-hidden"
           style="max-width: 100vh; max-height: 80vh">

        <div style="width: 100px" class="d-flex justify-content-center flex-column">
          <i class="fa fa-arrow-circle-left opacity-6-hover hover" v-show="blackoutImageIndex>0"
             @click="openImage('L',0,false)" style="color: #FFFFFF; font-size: 40px"></i>
        </div>
        <div v-if="images.length > 0">
          <div style="color: #FFFFFF; text-align: center" class="d-flex justify-content-center align-items-center">

            <div>{{ blackoutImageIndex + 1 }}/{{ images.length }}</div>
            <div v-if="subtitle !== ''" class="ml-2">- {{ subtitle }}</div>

          </div>
          <t-image-blob v-if="!blackoutImageZoomBusy" class="align-self-center m-2" :blob="blackoutImageZoomImage"/>

        </div>
        <t-msg v-else warning>Nenhuma imagem encontrada!</t-msg>

        <div style="width: 100px" class="d-flex justify-content-center flex-column">
          <i class="fa fa-arrow-circle-right opacity-6-hover hover" v-show="blackoutImageIndex<(images.length-1)"
             @click="openImage('R',0,false)" style="color: #FFFFFF; font-size: 40px"></i>
        </div>

      </div>

    </t-blackout>


  </div>

</template>
<script>
import tImageBlob from "@/components/template/theme/t-image-blob"
import http from "@/services/config/http-common";

let state;
let blackoutImageShow;

const handler_image_gallery = (e) => {

  if (!blackoutImageShow) {
    state = null //Nula para reduzir impacto de memoria
  } else {

    if (e.key === 'ArrowLeft') {
      state.openImage("L", 0, false)
    } else if (e.key === 'ArrowRight') {
      state.openImage("R", 0, false)
    }

  }


}

export default {
  name: 't-gallery',
  components: {tImageBlob},
  data() {
    return {
      localImages: [],
      blackoutImageZoom: true,
      blackoutImageZoomBusy: false,
      blackoutImageZoomImage: null,
      blackoutImageIndex: -1,
      subtitle: "",
      show: false,
    }
  },
  props: {
    title: String,
    images: Array,
    value: {
      type: null,
      required: true,
    },
  },
  mounted() {

    this.localImages = this.images

    this.openImage(false, 0, true)

    this.setShow(this.value)

  },
  computed: {

    onSending() {
      return this.status === "sending"
    },


  },
  methods: {

    setShow(value) {
      this.show = value
    },

    onBlackoutImage(show) {

      blackoutImageShow = show

      if (show) {
        state = this
        document.addEventListener('keydown', handler_image_gallery)
      } else {
        document.removeEventListener('keydown', handler_image_gallery)
      }

    },

    openImage(changePosition, index, openBlackout) {



      let indexImage = index

      if (changePosition === 'L') {

        if (this.blackoutImageIndex > 0) {
          this.blackoutImageIndex--
          indexImage = this.blackoutImageIndex
        } else {
          indexImage = this.images.length - 1
        }


      } else if (changePosition === 'R') {

        if (this.blackoutImageIndex < this.images.length - 1) {
          this.blackoutImageIndex++
          indexImage = this.blackoutImageIndex
        } else {
          indexImage = 0
        }

      }

      const path = this.localImages[indexImage].path
      const subtitle = this.localImages[indexImage].subtitle

      if (subtitle !== undefined && subtitle !== null)
        this.subtitle = subtitle

      this.blackoutImageIndex = indexImage
      this.blackoutImageZoomImage = null
      this.blackoutImageZoomBusy = true

      if (openBlackout) {
        this.blackoutImageZoom = true
      } else {
        this.blackoutImageZoomBusy = false
      }

      http.image(path).then((blob) => {
        this.blackoutImageZoomImage = blob
        this.blackoutImageZoomBusy = false
      })

    },


  },
  watch: {

    images(value) {
      this.localImages = value
    },

    show(value) {
      this.$emit("input", value)
    },

    async value(value) {
      await this.setShow(value)
      this.$emit("show", value)
    },

  }
}
</script>

